import { render, staticRenderFns } from "./_channels.vue?vue&type=template&id=4bb81dfe"
import script from "./_channels.vue?vue&type=script&lang=js"
export * from "./_channels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports